module.exports = __webpack_public_path__ + "e0bd6636a99b6fcbfe60fdb32d0d2a37.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_small_x1_variable/public/picture/Dining.jpg
// module id = 336
// module chunks = 0